import React from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import Navbar from "./components/Navbar/Navbar";
import AddTask from "./pages/AddTask";
import EditTask from "./pages/EditTask";
import Home from "./pages/Home";

const App = () => {
  return (
    <BrowserRouter>
      <Navbar />
      <Routes>
        <Route path="/" element={<Navigate to="/task" />} />
        <Route path="/task" element={<Home />} />
        <Route path="/task/add" element={<AddTask />} />
        <Route path="/task/edit/:taskId" element={<EditTask />} />
      </Routes>
    </BrowserRouter>
  );
};

export default App;
